import { formatPhone } from 'utils/formatPhone';
import { ICallerCallItem } from '../types';
import { callerDisplayName } from '../mappers';
import { ICustomerUI } from 'types/customer';
import ButtonEditCustomer from 'AppointmentBox/CustomerTab/ButtonEditCustomer';
import { Section, SectionLabel, CustomerRow, CustomerRowButton, Avatar, CustomerName, CustomerPhone, EditPencil } from './detail-styles';
import userIcon from '../icons/user.svg';
import editIcon from '../icons/edit.svg';

type Props = {
  item: ICallerCallItem;
  onCustomerUpdated?: (customer: ICustomerUI) => void;
};

// Avatar + name + phone — shared by both the editable and read-only rows.
const CustomerInfo = ({ item }: { item: ICallerCallItem }) => (
  <>
    <Avatar>
      <img src={userIcon} alt="" />
    </Avatar>
    <CustomerName>{callerDisplayName(item)}</CustomerName>
    <CustomerPhone>{`· ${formatPhone(item.phone)}`}</CustomerPhone>
  </>
);

// CUSTOMER section. For real callers the whole row is one large touch target that
// opens the shared edit-customer modal; otherwise it's a plain read-only row.
const CustomerSection = ({ item, onCustomerUpdated }: Props) => (
  <Section>
    <SectionLabel>CUSTOMER</SectionLabel>
    {item.customerId ? (
      <ButtonEditCustomer
        customerId={Number(item.customerId)}
        onSelect={(customer) => onCustomerUpdated?.(customer)}
        renderButton={({ onClick }) => (
          <CustomerRowButton type="button" onClick={onClick} aria-label="Edit customer">
            <CustomerInfo item={item} />
            <EditPencil>
              <img src={editIcon} alt="" />
            </EditPencil>
          </CustomerRowButton>
        )}
      />
    ) : (
      <CustomerRow>
        <CustomerInfo item={item} />
      </CustomerRow>
    )}
  </Section>
);

export default CustomerSection;
